import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { blogPosts } from '../blog/data';
import { createSortaFriendsClickHandler } from '../utils/navigation';

const Blog = () => {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBlogPosts();
  }, []);

  const loadBlogPosts = async () => {
    try {
      // Sort posts by date (oldest first)
      const sortedPosts = blogPosts.sort((a, b) => new Date(a.date) - new Date(b.date));
      setPosts(sortedPosts);
      setLoading(false);
    } catch (error) {
      console.error('Error loading blog posts:', error);
      setLoading(false);
    }
  };

  const handleBackToHomepage = () => {
    window.location.href = 'https://www.sortafriends.com';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div>
        <header className="header">
          <div className="container">
            <div className="header-content">
              <h1 style={{ cursor: 'pointer' }} onClick={createSortaFriendsClickHandler(navigate)}>SortaFriends</h1>
            <button
              onClick={handleBackToHomepage}
              className="btn"
              style={{ backgroundColor: 'var(--color-primary)', color: 'white', border: 'none' }}
            >
              Back to Homepage
            </button>
            </div>
          </div>
        </header>
        <div className="container">
          <div className="card">
            <p>Loading blog posts...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <header className="header">
        <div className="container">
          <div className="header-content">
            <h1 style={{ cursor: 'pointer' }} onClick={createSortaFriendsClickHandler(navigate)}>SortaFriends</h1>
            <button
              onClick={handleBackToHomepage}
              className="btn"
              style={{ backgroundColor: 'var(--color-primary)', color: 'white', border: 'none' }}
            >
              Back to Homepage
            </button>
          </div>
        </div>
      </header>

      <div className="container">
        <div className="card">
          <h1>Developer Blog</h1>

          <div className="blog-posts">
            {posts.map((post) => (
              <article key={post.id} className="blog-post">
                <header className="blog-post-header">
                  <h2 className="blog-post-title">{post.title}</h2>
                  <div className="blog-post-meta">
                    <span className="blog-post-date">{formatDate(post.date)}</span>
                    <span className="blog-post-author">by {post.author}</span>
                  </div>
                </header>
                <div className="blog-post-content">
                  <ReactMarkdown 
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw]}
                    components={{
                      // Custom styling for markdown elements
                      h1: ({children}) => <h1 style={{color: 'var(--color-text)', marginTop: '20px', marginBottom: '15px'}}>{children}</h1>,
                      h2: ({children}) => <h2 style={{color: 'var(--color-text)', marginTop: '20px', marginBottom: '15px'}}>{children}</h2>,
                      h3: ({children}) => <h3 style={{color: 'var(--color-text)', marginTop: '15px', marginBottom: '10px'}}>{children}</h3>,
                      p: ({children}) => <p style={{color: 'var(--color-text)', lineHeight: '1.6', marginBottom: '15px'}}>{children}</p>,
                      ul: ({children}) => <ul style={{color: 'var(--color-text)', marginBottom: '15px', paddingLeft: '20px'}}>{children}</ul>,
                      ol: ({children}) => <ol style={{color: 'var(--color-text)', marginBottom: '15px', paddingLeft: '20px'}}>{children}</ol>,
                      li: ({children}) => <li style={{marginBottom: '5px'}}>{children}</li>,
                      code: ({children}) => <code style={{backgroundColor: 'var(--color-elevated)', padding: '2px 4px', borderRadius: '3px', fontFamily: 'monospace'}}>{children}</code>,
                      pre: ({children}) => <pre style={{backgroundColor: 'var(--color-elevated)', padding: '15px', borderRadius: '5px', overflow: 'auto', marginBottom: '15px'}}>{children}</pre>,
                      blockquote: ({children}) => <blockquote style={{borderLeft: '4px solid var(--color-primary)', paddingLeft: '15px', margin: '15px 0', fontStyle: 'italic', color: 'var(--color-text-muted)'}}>{children}</blockquote>,
                      a: ({children, href}) => <a href={href} style={{color: 'var(--color-primary)', textDecoration: 'none'}} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>{children}</a>,
                      img: ({src, alt}) => <img src={src} alt={alt} style={{maxWidth: '100%', height: 'auto', borderRadius: '6px', margin: '20px 0', boxShadow: '0 2px 8px var(--color-shadow)'}} />,
                      iframe: ({src, title, ...props}) => (
                        <iframe 
                          src={src} 
                          title={title}
                          {...props}
                          style={{
                            width: '100%',
                            height: '400px',
                            borderRadius: '6px',
                            margin: '20px 0',
                            boxShadow: '0 2px 8px var(--color-shadow)',
                            border: 'none'
                          }}
                        />
                      )
                    }}
                  >
                    {post.content}
                  </ReactMarkdown>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
